//core
import {useDispatch} from "react-redux";
import {
  getListData,
  getFiltersData,
  getAdjustmentListData,
  getAdjustmentReasonsData,
  getAdjustmentBrandsData,
  setAdjustmentAddData,
  setAdjustmentEditData,
  setAdjustmentApproveData,
  setAdjustmentRemoveData,
  getDownloadDetailsReport,
  setPaymentData,
  clearPaymentData,
  clearManagerApproveData,
  PaymentSetData,
  setManagerApproveData,
  IApproveReports,
  setFinManagerApproveData,
  clearFiltersData,
  setCancelManagerApproveData,
  clearCancelManagerApproveData,
  setToPaidApproveData,
  clearToPaidApproveData,
  setCarryOverApproveData,
  clearCarryOverApproveData,
  clearAdjustmentEditData,
  clearAdjustmentAddData,
  clearAdjustmentListData,
  clearDetailsListData,
  setCancelCarryOverApproveData,
  clearCancelCarryOverApproveData,
  setChangeCommentData,
  clearChangeCommentData,
  setAdjustmentApprovePaidData,
  getFiltersField,
  getBrandsListData,
  getReportRowData,
  clearReportRowData,
  getColumnsData,
  clearColumnsState,
  getPaymentBreakdownData,
  clearPaymentBreakdownData,
} from "./index";

export const useDetailsFinReport = () => {
  const dispatch = useDispatch();

  const getTableList = (data: any) => dispatch(getListData(data));
  const getFiltersList = (data: any) => dispatch(getFiltersData(data));
  const getFiltersFieldData = (data: any) => dispatch(getFiltersField(data));
  const clearFiltersList = () => dispatch(clearFiltersData());
  const getAdjustmentList = (data: any) => dispatch(getAdjustmentListData(data));
  const getAdjustmentReasons = (data: any) => dispatch(getAdjustmentReasonsData(data));
  const getAdjustmentBrands = () => dispatch(getAdjustmentBrandsData());
  const setAdjustmentAdd = (data: any) => dispatch(setAdjustmentAddData(data));
  const clearAdjustmentAddState = () => dispatch(clearAdjustmentAddData());
  const setAdjustmentEdit = (data: any) => dispatch(setAdjustmentEditData(data));
  const clearAdjustmentEditState = () => dispatch(clearAdjustmentEditData());
  const setAdjustmentApprove = (data: any) => dispatch(setAdjustmentApproveData(data));
  const setAdjustmentApprovePaid = (data: any) => dispatch(setAdjustmentApprovePaidData(data));
  const setAdjustmentRemove = (data: any) => dispatch(setAdjustmentRemoveData(data));
  const downloadDetailsReport = (data: any) => dispatch(getDownloadDetailsReport(data));
  const clearAdjustmentListState = () => dispatch(clearAdjustmentListData());
  const clearDetailsListState = () => dispatch(clearDetailsListData());

  const setPayment = (data: PaymentSetData) => dispatch(setPaymentData(data));
  const clearPaymentState = () => dispatch(clearPaymentData());

  const setManagerApprove = (data: IApproveReports) => dispatch(setManagerApproveData(data));
  const clearManagerApproveState = () => dispatch(clearManagerApproveData());
  const setCancelManagerApprove = (data: IApproveReports) => dispatch(setCancelManagerApproveData(data));
  const clearCancelManagerApproveState = () => dispatch(clearCancelManagerApproveData());

  const setFinManagerApprove = (data: IApproveReports) => dispatch(setFinManagerApproveData(data));

  const setToPaidApprove = (data: IApproveReports) => dispatch(setToPaidApproveData(data));
  const clearToPaidApprove = () => dispatch(clearToPaidApproveData());

  const setCarryOverApprove = (data: IApproveReports) => dispatch(setCarryOverApproveData(data));
  const clearCarryOverApprove = () => dispatch(clearCarryOverApproveData());
  const setCancelCarryOverApprove = (data: IApproveReports) => dispatch(setCancelCarryOverApproveData(data));
  const clearCancelCarryOverApprove = () => dispatch(clearCancelCarryOverApproveData());

  const setChangeComment = (data: any) => dispatch(setChangeCommentData(data));
  const clearChangeCommentState = () => dispatch(clearChangeCommentData());

  const getBrandsList = (data: any) => dispatch(getBrandsListData(data));

  const getReportRow = (data: any) => dispatch(getReportRowData(data));
  const clearReportRow = () => dispatch(clearReportRowData());

  const getColumns = () => dispatch(getColumnsData());
  const clearColumns = () => dispatch(clearColumnsState());

  const getPaymentBreakdown = (data: any) => dispatch(getPaymentBreakdownData(data));
  const clearPaymentBreakdown = () => dispatch(clearPaymentBreakdownData());


  return {
    getTableList,
    getFiltersList,
    clearFiltersList,
    getAdjustmentList,
    getAdjustmentReasons,
    getAdjustmentBrands,
    setAdjustmentAdd,
    setAdjustmentEdit,
    setAdjustmentApprove,
    setAdjustmentRemove,
    downloadDetailsReport,
    setPayment,
    clearPaymentState,
    setManagerApprove,
    clearManagerApproveState,
    setFinManagerApprove,
    setCancelManagerApprove,
    clearCancelManagerApproveState,
    setToPaidApprove,
    clearToPaidApprove,
    setCarryOverApprove,
    clearCarryOverApprove,
    clearAdjustmentEditState,
    clearAdjustmentAddState,
    clearAdjustmentListState,
    clearDetailsListState,
    setCancelCarryOverApprove,
    clearCancelCarryOverApprove,
    setChangeComment,
    clearChangeCommentState,
    setAdjustmentApprovePaid,
    getFiltersFieldData,
    getBrandsList,
    getReportRow,
    clearReportRow,
    getColumns,
    clearColumns,
    getPaymentBreakdown,
    clearPaymentBreakdown
  }
}
